(() => {
  'use strict';

  if (window.SparkMotoNotificationInitialized) return;
  window.SparkMotoNotificationInitialized = true;

  const isSpecialWorx = () => {
    return (
      document.documentElement.classList.contains('specialworx-mode') ||
      window.location.pathname.replace(/\/$/, '') === '/pages/specialworx' ||
      !!document.querySelector('cart-drawer.sw-parts-bin')
    );
  };

  if (isSpecialWorx()) return;

  const STYLE_ID = 'spark-moto-notification-styles';
  const NOTIFICATION_ID = 'spark-moto-cart-notification';

  let closeTimer = null;

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      @font-face {
        font-family: "SparkMotoPLANK";
        src: url("https://cdn.shopify.com/s/files/1/0786/7662/3435/files/PLANK.TTF?v=1793072042") format("truetype");
        font-display: swap;
      }

      #${NOTIFICATION_ID} {
        position: fixed;
        top: 100px;
        right: 20px;
        width: min(390px, calc(100vw - 32px));
        padding: 20px;
        background: #111;
        color: #fff;
        border: 1px solid #fff;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.4);
        z-index: 2147483000;
        box-sizing: border-box;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-12px);
        transition: opacity .2s ease, transform .2s ease, visibility .2s ease;
      }

      #${NOTIFICATION_ID}.sm-visible {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      #${NOTIFICATION_ID},
      #${NOTIFICATION_ID} * {
        box-sizing: border-box;
      }

      #${NOTIFICATION_ID} .sm-notification-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 16px;
      }

      #${NOTIFICATION_ID} .sm-notification-title {
        font-family: "SparkMotoPLANK", sans-serif;
        font-size: 18px;
        letter-spacing: .5px;
        line-height: 1.3;
      }

      #${NOTIFICATION_ID} .sm-notification-close {
        background: transparent;
        color: #fff;
        border: 0;
        padding: 6px;
        font-size: 25px;
        line-height: 1;
        cursor: pointer;
      }

      #${NOTIFICATION_ID} .sm-notification-product {
        display: flex;
        gap: 14px;
        align-items: flex-start;
        margin-bottom: 20px;
      }

      #${NOTIFICATION_ID} .sm-notification-image {
        width: 90px;
        height: 100px;
        object-fit: cover;
        background: #222;
        flex-shrink: 0;
      }

      #${NOTIFICATION_ID} .sm-notification-details {
        min-width: 0;
        flex: 1;
      }

      #${NOTIFICATION_ID} .sm-notification-name {
        font-family: "SparkMotoPLANK", sans-serif;
        font-size: 16px;
        line-height: 1.4;
        margin-bottom: 8px;
        overflow-wrap: anywhere;
      }

      #${NOTIFICATION_ID} .sm-notification-variant {
        font-size: 13px;
        line-height: 1.5;
        color: #ccc;
        overflow-wrap: anywhere;
      }

      #${NOTIFICATION_ID} .sm-notification-view {
        width: 100%;
        min-height: 48px;
        padding: 12px;
        background: #fff;
        color: #000;
        border: 1px solid #fff;
        font-family: "SparkMotoPLANK", sans-serif;
        font-size: 16px;
        cursor: pointer;
      }

      #${NOTIFICATION_ID} .sm-notification-view:hover {
        background: #ddd;
      }

      @media (max-width: 749px) {
        #${NOTIFICATION_ID} {
          top: 80px;
          right: 16px;
          padding: 16px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #${NOTIFICATION_ID} {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createNotification() {
    let notification = document.getElementById(NOTIFICATION_ID);

    if (notification) return notification;

    notification = document.createElement('div');
    notification.id = NOTIFICATION_ID;
    notification.setAttribute('role', 'status');
    notification.setAttribute('aria-live', 'polite');

    notification.innerHTML = `
      <div class="sm-notification-heading">
        <span class="sm-notification-title">✓ ADDED TO YOUR BAG</span>
        <button class="sm-notification-close" type="button" aria-label="Close notification">×</button>
      </div>

      <div class="sm-notification-product">
        <img class="sm-notification-image" alt="" hidden>
        <div class="sm-notification-details">
          <div class="sm-notification-name"></div>
          <div class="sm-notification-variant"></div>
        </div>
      </div>

      <button class="sm-notification-view" type="button">VIEW BAG →</button>
    `;

    notification
      .querySelector('.sm-notification-close')
      .addEventListener('click', closeNotification);

    notification
      .querySelector('.sm-notification-view')
      .addEventListener('click', () => {
        closeNotification();

        const drawer = document.querySelector('cart-drawer.sm-clothing-bag');

        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      });

    document.body.appendChild(notification);

    return notification;
  }

  function closeNotification() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    document.getElementById(NOTIFICATION_ID)?.classList.remove('sm-visible');
  }

  function showNotification(product) {
    if (isSpecialWorx()) return;

    installStyles();

    const notification = createNotification();

    const image = notification.querySelector('.sm-notification-image');
    const name = notification.querySelector('.sm-notification-name');
    const variant = notification.querySelector('.sm-notification-variant');

    name.textContent = product?.product_title || product?.title || 'Product added';

    const options = [];

    if (Array.isArray(product?.options_with_values)) {
      product.options_with_values.forEach((option) => {
        if (option?.value && option.value !== 'Default Title') {
          options.push(`${option.name}: ${option.value}`);
        }
      });
    } else if (product?.variant_title && product.variant_title !== 'Default Title') {
      options.push(product.variant_title);
    }

    variant.textContent = options.join(' • ');

    const imageUrl = product?.featured_image?.url || product?.image || '';

    if (imageUrl) {
      image.src = imageUrl;
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
    }

    notification.classList.add('sm-visible');

    if (closeTimer) clearTimeout(closeTimer);

    closeTimer = setTimeout(closeNotification, 5000);
  }

  window.SparkMotoNotification = {
    show: showNotification,
    close: closeNotification
  };
})();